import { useGetAuthorizationByIdQuery } from '../services';

const useAuthorization = (id: string) => {
  const { data: authorization, isLoading: isAuthorizationLoading } =
    useGetAuthorizationByIdQuery({ id }, { skip: !id });

  return {
    authorization,
    isAuthorizationLoading,
  };
};

export default useAuthorization;
